import { render, staticRenderFns } from "./AddTiers.vue?vue&type=template&id=584d2de9&"
import script from "./AddTiers.vue?vue&type=script&lang=js&"
export * from "./AddTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports